import { memo, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { getAppliedParamsValues } from '~/components/Filters/FiltersBar/filtersBarUtils';
import { FilterTrigger } from '~/components/Filters/SingleFilters/FilterTrigger';
import { SingleSmartTagFilter } from '~/components/Filters/SmartTagsFilter/SingleSmartTagFilter';
import { type SingleFilterProps } from '~/components/Filters/types';
import { baseFiltersOptions } from '~/components/FiltersMenu/types';
import { useFilterParams } from '~/hooks/filters/useFilterParams';
import { removeFilterAction } from '~/store/filters/actions';
import { type SelectedFilter } from '~/store/filters/types';

export type SmartTagFilterTriggerProps = SingleFilterProps;

export const SmartTagFilterTrigger = memo(
  ({ onApplyClick, onRemoveClick, onOpenChange }: SmartTagFilterTriggerProps) => {
    const dispatch = useDispatch();
    const { smartTagsParam } = useFilterParams();

    const content = useMemo(() => <SingleSmartTagFilter onApplyClick={onApplyClick} />, [onApplyClick]);

    const appliedSmartTagsValues = useMemo(() => getAppliedParamsValues(smartTagsParam), [smartTagsParam]);

    const removeFilter = useCallback(async () => {
      const filter: SelectedFilter = { type: 'smartTags' };
      dispatch(removeFilterAction({ filter }));
      onRemoveClick?.([filter]);
    }, [dispatch, onRemoveClick]);

    return (
      <FilterTrigger
        filterContent={content}
        title={baseFiltersOptions['smartTags'].label}
        values={appliedSmartTagsValues}
        onRemoveClick={removeFilter}
        Icon={baseFiltersOptions['smartTags'].icon}
        onOpenChange={onOpenChange}
      />
    );
  },
);

SmartTagFilterTrigger.displayName = 'SmartTagFilterTrigger';
